import { Component, Input } from '@angular/core';
import StickerPart from 'src/app/model/product/windowsticker/sticker-part';

@Component({
  selector: 'client-window-sticker-custom-part-form',
  templateUrl: './client-window-sticker-custom-part-form.component.html',
  styleUrls: ['./client-window-sticker-custom-part-form.component.scss']
})
export class ClientWindowStickerCustomPartFormComponent {
  @Input()
  stickerPart: StickerPart;

  fillStickerSizes(): void {
    this.stickerPart.stickerHeight = this.stickerPart.windowHeight;
    this.stickerPart.stickerWidth = this.stickerPart.windowWidth;
  }

  descriptionChanged(value: string): void {
    this.stickerPart.description = value;
  }
}
